import { createUseStyles } from 'react-jss';
export default createUseStyles({
  container: {
    width: '100%',
    display: "flex",
    position: 'relative',
    marginBottom: 20,
    marginTop: 5
  },

  pageItem: {
    color: '#4E4E4E',
    marginRight: 20,
    cursor: 'pointer',
    fontWeight: 'bold',
    

    '&.selected': {
      color: '#4E4E4E'
    }
  },

  underline: {
    position: 'absolute',
    borderRadius: 50,
    height: 3,
    backgroundColor: "#004f9f",
    left: 0,
    top: 25,
    transition: '0.5s'
  },

  '@media (max-width: 540px)': {
    pageItem: {
      fontSize: 13
    }
  },
})